import { render, staticRenderFns } from "./Form00.vue?vue&type=template&id=479d87de&"
import script from "./Form00.vue?vue&type=script&lang=js&"
export * from "./Form00.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports